import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShoppingBag3"><Path fillRule="evenodd" clipRule="evenodd" d="M7 3H17V7H15V5H9V7H7V3Z" fill="currentColor"/><Path d="M3 21V7H7V12H9V7H15V12H17V7H21V21H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag3;
